import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { defaultMessages } from './lang/default';

// Keep the initializers before the other imports from this repo.
import { register as registerSwiper } from 'swiper/element/bundle';
import './initializers/axios';
import './initializers/consent-banner';
import { rollbar } from './initializers/rollbar';

import NotifierPlugin from '@/plugins/notifier';
import App from './App.vue';
import router from './router';

declare global {
  interface Window {
    // ToDo review this props
    productsUIEvents: any;
    backstageAppEvents: any;
    backstageApp: any;
    dataLayer: any[];
  }
}

// register Swiper custom elements
registerSwiper();

const app = createApp(App);

app.use(createPinia());
app.use(createI18n({ legacy: false, locale: 'default', messages: { default: defaultMessages } }));
app.use(router);
app.use(NotifierPlugin);

app.config.errorHandler = (err) => {
  rollbar.error(err as any);
  throw err; // rethrow
};
app.config.globalProperties.$rollbar = rollbar;

app.mount('#backstage-ui');
